import { useState } from "react";

import { Panes } from "dev";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { TabBar } from "ui";

export default function TabBarPage() {
  return (
    <Panes showBorder>
      <ExampleTabBar title="simple" />
      <ExampleTabBar
        title="scrolling enabled"
        values={[
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
          "ten",
          "eleven",
          "twelve",
        ]}
      />
      <ExampleTabBar title="disabled tabs (TODO: not implemented)" />
    </Panes>
  );
}

function ExampleTabBar({
  title,
  values = ["one", "two", "three"],
}: {
  title: string;
  values?: string[];
}) {
  const [selectedValue, setSelectedValue] = useState(values[0]);
  const tailwind = useTailwind();

  return (
    <View>
      <Text style={tailwind("text-center m-4")}>{title}</Text>
      <TabBar
        values={values}
        selectedValue={selectedValue}
        selectValue={setSelectedValue}
      />
    </View>
  );
}
